import { useQueries } from "@tanstack/react-query";
import { EndpointsService } from "../services/endpoints/endpoints.service";
import { BackendPagination } from "../models/pagination.model";
import { AlertCategory } from "../models/entities/alert-category.model";

/**
 * Fetches unresolved task count per alert category (for sub-tab badges).
 * Uses reason+details filters from each category (included in RSQL).
 */
export const useTasksCountsByCategory = (
	categories: AlertCategory[],
	getBackendPaginationForCategory: (category: AlertCategory) => BackendPagination
): Record<string, number> => {
	const results = useQueries({
		queries: categories.map((cat) => {
			const pagination = getBackendPaginationForCategory(cat);
			return {
				queryKey: ["participants-alerts-tasks-count", pagination],
				queryFn: async () => {
					const response = await EndpointsService.dataRetriever.getTasksCount({
						config: {
							params: {
								search: pagination.search,
								filters: pagination.filters,
							},
						},
					});
					return response;
				},
			};
		}),
	});

	const counts: Record<string, number> = {};
	categories.forEach((cat, i) => {
		counts[cat.id] = results[i].data ?? 0;
	});
	return counts;
};
